import { operations } from "types/openapi";
import { api } from "./api";
import { ENDPOINTS } from "./endpoints";
import { TRequestValues } from "./authClient/auth/api-utils";

type getNominalAccountOperation = operations["getNominalAccount"];
type getAllRubWithdrawalRequests = operations["findAll_1"];
type startProcessingRubWithdrawal = operations["startProcessing"];
type completeProcessingRubWithdrawal = operations["complete"];
type cancelProcessingRubWithdrawal = operations["cancel"];
type getAllRubOperations = operations["findAll_2"];
type rubOperationDeposit = operations["deposit"];
type getPLatformDetails = operations["getPlatformDetails"]["responses"]["200"]["content"]["*/*"];
type getFeeStatisticsOperation = operations["getFeeStatistics"]["responses"]["200"]["content"]["*/*"];
type getNominalAccountBankAccountsForBeneficiaryOperation =
  operations["getBeneficiaryBankAccounts"]["responses"]["200"]["content"]["*/*"];

/**
 * Получение номинальных счетов
 */
export const getNominalAccountsUserBalance = (): Promise<
  getNominalAccountOperation["responses"]["200"]["content"]["*/*"]
> => {
  return api.get(ENDPOINTS.nominalAccounts());
};

/**
 * Получение общего баланса номинальных счетов
 */
export const getNominalAccountsOverallBalance = (): Promise<
  getNominalAccountOperation["responses"]["200"]["content"]["*/*"]
> => {
  return api.get(ENDPOINTS.nominalAccountOverallBalance());
};

/**
 * Начать обработку заявки на вывод рублей
 */
export const startProcessingRubWithdrawalRequest = (bidId: string): Promise<startProcessingRubWithdrawal> => {
  return api.post(ENDPOINTS.startProcessingRubWithdrawalRequest(bidId));
};

/**
 * Подтверждение исполнения заявки на вывод рублей
 */
export const completeRubWithdrawalRequest = (
  bidId: string,
  formData: any
): Promise<completeProcessingRubWithdrawal> => {
  return api.post(ENDPOINTS.completeRubWithdrawalRequest(bidId), formData);
};

/**
 * Отмена заявки на вывод рублей
 */
export const cancelRubWithdrawalRequest = (bidId: string): Promise<cancelProcessingRubWithdrawal> => {
  return api.post(ENDPOINTS.cancelRubWithdrawalRequest(bidId));
};

export const getWithdrawalRequests = (
  params: Record<string, TRequestValues>
): Promise<getAllRubWithdrawalRequests["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.rubWithdrawalRequest(), params);
};

export const getRubOperations = (
  params: Record<string, TRequestValues>
): Promise<getAllRubOperations["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.rubOperations(), params);
};

/** Подтвердить депозит для роли Оператора*/
export const rubOperationsDepositRequest = (formData: any): Promise<rubOperationDeposit> => {
  return api.post(ENDPOINTS.rubOperationDeposit(), formData);
};

/**
 * Банковские реквизиты платформы
 */

export const getPlatformDetailsRequest = (): Promise<getPLatformDetails> => {
  return api.get(ENDPOINTS.getPlatformDetails());
};

/**
 * Получение статистики комиссий платформы
 */
export const getFeeStatistics = (): Promise<getFeeStatisticsOperation> => {
  return api.get(ENDPOINTS.getPlatformFeeStatistics());
};

/**
 * Получение банковских реквизитов бенефициара
 */
export const getNominalAccountBankAccountsForBeneficiary = (
  id: string
): Promise<getNominalAccountBankAccountsForBeneficiaryOperation> => {
  return api.get(ENDPOINTS.nominalAccountBankAccountsForBeneficiary(id));
};
